.mo-header {
  font-family: "Benton-Regular";
  width: 100%;
  background: #9930e2;
  color: #ffffff;
  padding: 12px 0;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
}
.mo-header__logo {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  padding-right: 15px;
  margin-right: 12px;
  width: 100px;
}
.mo-header__content {
  display: flex;
  justify-content: center;
  align-items: center;
}
.mo-header__logo::after {
  content: "";
  width: 2px;
  height: 23px;
  background-color: #fff;
  position: absolute;
  right: 0;
  top: calc(50% - 12px);
}
.mo-header__logo svg {
  width: 100%;
}
.mo-header p {
  margin: 0;
  font-size: 14px;
  margin-right: 12px;
  font-family: 'Benton-Light';
}
.mo-header p b {
  font-family: "Benton-Bold";
  font-weight: 300;
}

.mo-header__button.desktop {
  display: block;
}
.mo-header__button.mobile {
  display: none;
}
@media (max-width: 768px) {
  .mo-header {
    width: unset;
    flex-direction: column;
    align-items: flex-start;
    text-align: left;
    padding: 20px 15px;
  }
  .mo-header__logo {
    margin-bottom: 4px;
  }
  .mo-header__content {
    width: 100%;
    justify-content: space-between;
    align-items: center;
  }
  .mo-header__logo::after {
    display: none;
  }
  .mo-header p {
    width: 218px;
  }
  .mo-header__button.desktop {
    display: none;
  }
  .mo-header__button.mobile {
    display: block;
  }
}
